export default __webpack_public_path__ + "static/media/logo.e04a3eda.png";